module.exports = __webpack_public_path__ + "static/media/pen-fancy.3f09512a.svg";